import { Input } from 'antd';
import styled from 'styled-components';
import './header.less';
import { SearchOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
const InboxHeaderContainer = styled.div`
  width: 672px;
  height: 52px;
  margin: -24px auto;
  position: relative;
  z-index: 12;
`;
export const InboxHeader = (props: { onChange: (val: string) => void }) => {
  const { t } = useTranslation();
  const [val, setVal] = useState('');
  return (
    <InboxHeaderContainer className="inbox_header">
      <Input
        value={val}
        onChange={(e) => {
          setVal(e.target.value);
        }}
        addonBefore={<SearchOutlined />}
        // onBlur={(e) => {
        //   props.onChange(e.target.value);
        // }}
        onKeyPress={(event) => {
          if (event.key === 'Enter' && !event.shiftKey) {
            event.preventDefault();
            props.onChange(val);
          }
        }}
        className="input"
        allowClear
        placeholder={t('life.inbox.placeHolder')}
      ></Input>
    </InboxHeaderContainer>
  );
};
